<div class="main-content">
  <div class="top">
    <mat-card class="top-card" appearance="outlined">
      <mat-card-header class="back-color-secondary">
        <mat-card-title>
          <mat-icon>login</mat-icon>
          <span style="padding-left: 12px">Login</span>
        </mat-card-title>
      </mat-card-header>
    </mat-card>
  </div>

  <div class="main">
    <form *ngIf="!app.accessToken" #form="ngForm" (ngSubmit)="login()">
      <div class="field-container-vert">

        <mat-form-field appearance="fill" subscriptSizing="dynamic" [hideRequiredMarker]="!!name">
          <mat-label>User</mat-label>
          <input required matInput [(ngModel)]="name" name="username" autocomplete="username">
        </mat-form-field>

        <mat-form-field appearance="fill" subscriptSizing="dynamic" [hideRequiredMarker]="!!password">
          <mat-label>Password</mat-label>
          <input required matInput [(ngModel)]="password" name="password" type="password" autocomplete="new-password">
        </mat-form-field>

        <div class="container-horz-hcenter-vcenter">
          <button mat-stroked-button color="primary" class="button-save" type="submit" id="submit">
            <mat-icon>login</mat-icon>
            Login
          </button>
        </div>

        <div class="container-horz-hcenter-vcenter">
          <a [routerLink]="'/reset-password'">I forgot my password</a>
        </div>
      </div>
    </form>

    <div *ngIf="app.accessToken" class="field-container-vert">
      <div class="placeholder-text">You are already logged in</div>

      <div class="container-horz-hcenter-vcenter">
        <button mat-stroked-button color="primary" class="button-save" (click)="app.logout()">
          <mat-icon>logout</mat-icon>
          Logout
        </button>
      </div>
    </div>
  </div>
</div>